import { type FC } from 'react';
import {
  Browsers
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconBrowsersProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconBrowsers: FC<UiIconBrowsersProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Browsers}
      {...props}
    />
  );
};
